import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from 'react-responsive-carousel'

import Cross from '../../../assets/Icons/cross.svg'
import './styles.css'

export default (props)=>{

    const handleClose= () =>{
        props.setShow(false)
    }

    return(
        <div>
            <Dialog
                open={props.showModal} 
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title" 
                maxWidth='md'
            >
                <DialogContent>
                <div>
                    <img src={Cross} alt="" onClick={handleClose} className='cross-modal'/>
                </div><br/><br/>

                {props.establishment === 'ntem' ?
                    <><p className='reddd'>*Comprovante de residência não fornecido</p><br/></>:null
                }
                
                <div className='docs-carousel'>

                    {props.establishment === 'ntem' ?
                        <Carousel>
                            <div>
                                <img src={props.cpf} alt=''/>
                                <p className="legend">DOCUMENTO</p>
                            </div>
                        </Carousel> 
                        :
                        <Carousel>
                            <div>
                                <img src={props.cpf} alt=''/>
                                <p className="legend">DOCUMENTO</p>
                            </div>

                            <div>
                                <img src={props.establishment} alt=''/>
                                <p className="legend">COMPROVANTE DE RESIDÊNCIA</p>
                            </div> 
                        </Carousel>
                    }
                </div>
                    
                </DialogContent>
            </Dialog>
        </div>
    )
}